export default function deleteActionCreators(resourceName, key, actionTypes, api) {
	if (resourceName == null) throw new Error('actionCreatorsFor: Expected resourceName');

	let actionCreators = {

		delete: function (id, token, params) {
			return function (dispatch) {
				dispatch(actionCreators.request());

				return api.del(id, token, params)
					.then(
						response => dispatch(actionCreators.success(response)),
						error => dispatch(actionCreators.failure(error))
					).then(
						response => dispatch(actionCreators.complete()),
						error => dispatch(actionCreators.complete())
					);
			}
		},

		request: function () {
			let name = resourceName + '_DELETE_REQUEST';

			return {
				type: actionTypes[name]
			}
		},

		success: function (data) {
			let name = resourceName + '_DELETE_SUCCESS';

			return {
				data: data.data,
				type: actionTypes[name]
			}
		},

		complete: function () {
			let name = resourceName + '_DELETE_COMPLETE';

			return {
				data: {},
				type: actionTypes[name]
			}
		},

		failure: function (error, data) {
			let name = resourceName + '_DELETE_FAILURE';

			return {
				data: data,
				error: error,
				type: actionTypes[name]
			}
		}
	};

	return actionCreators;
}